document.addEventListener('DOMContentLoaded', function () {
    const root = document.querySelector('[data-contact]');
    if (!root) return;

    const locBar = root.querySelector('.contact__locations-box');
    if (!locBar) return;

    const buttons = Array.from(root.querySelectorAll('.contact__locations .button'));
    const info = Array.from(root.querySelectorAll('.contact__info-pane'));
    const forms = Array.from(root.querySelectorAll('.contact__form-pane'));
    function updateTopicSelectFor(idx) {
        const activePane = root.querySelector('.contact__form-pane.is-active');
        if (!activePane) return;

        const want = idx + 1;
        const selects = activePane.querySelectorAll('select.topic-select');

        selects.forEach(sel => {
            const match = sel.classList.contains(`location--${want}`);
            sel.disabled = !match;

            const wrap = sel.closest('p');
            if (wrap) wrap.classList.toggle('is-hidden', !match);

            if (match) {
                if (typeof initCustomSelect === 'function' && sel.dataset.customized !== 'true') {
                    initCustomSelect(sel);
                }

                const triggerSpan = wrap && wrap.querySelector('.custom-select__trigger span');
                if (triggerSpan) {
                    const opt = sel.options[sel.selectedIndex] || sel.options[0];
                    if (opt) triggerSpan.textContent = opt.text;
                }
            }
        });
    }

    function setActive(idx) {
        const i = Math.max(0, Math.min(idx, buttons.length - 1));
        locBar.setAttribute('data-active', String(i));
        root.setAttribute('data-active', String(i));

        buttons.forEach((b, k) => {
            const on = k === i;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        info.forEach(p => p.classList.toggle('is-active', Number(p.dataset.pane) === i));
        forms.forEach(p => p.classList.toggle('is-active', Number(p.dataset.pane) === i));

        updateTopicSelectFor(i);
    }

    setActive(Number(locBar.getAttribute('data-active') || 0) || 0);

    locBar.addEventListener('click', (e) => {
        const btn = e.target.closest('.button');
        if (!btn) return;

        const i = Number(btn.dataset.index || 0) || 0;
        setActive(i);

        const track = locBar;
        const item = btn;

        const trackRect = track.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();


        const delta = itemRect.left - trackRect.left;

        const extraPadding = 24;

        const targetScroll = track.scrollLeft + delta - extraPadding;

        track.scrollTo({
            left: targetScroll,
            behavior: 'smooth'
        });
    });

    function initCustomSelect(nativeSelect) {
        if (nativeSelect.dataset.customized === 'true') return;
        nativeSelect.dataset.customized = 'true';

        const wrap = document.createElement('div');
        wrap.className = 'custom-select';
        nativeSelect.classList.add('custom-select__native');
        nativeSelect.parentNode.insertBefore(wrap, nativeSelect);
        wrap.appendChild(nativeSelect);

        const trigger = document.createElement('div');
        trigger.className = 'custom-select__trigger';
        const span = document.createElement('span');
        span.textContent = nativeSelect.options[nativeSelect.selectedIndex]?.text || nativeSelect.options[0]?.text || '';
        trigger.appendChild(span);

        wrap.appendChild(trigger);

        const list = document.createElement('div');
        list.className = 'custom-select__options';
        Array.from(nativeSelect.options).forEach((opt, i) => {
            const optEl = document.createElement('div');
            optEl.className = 'custom-select__option' + (opt.selected ? ' is-selected' : '');
            optEl.dataset.value = opt.value;
            optEl.textContent = opt.text;
            optEl.addEventListener('click', () => {
                selectOption(optEl, nativeSelect, wrap);
            });
            list.appendChild(optEl);
        });
        wrap.appendChild(list);

        trigger.addEventListener('click', e => {
            e.stopPropagation();
            wrap.classList.toggle('is-open');
        });
        document.addEventListener('click', e => {
            if (!wrap.contains(e.target)) wrap.classList.remove('is-open');
        });

        nativeSelect.addEventListener('change', () => {
            const val = nativeSelect.value;
            const activeOpt = list.querySelector(`.custom-select__option[data-value="${CSS.escape(val)}"]`);
            if (activeOpt) selectOption(activeOpt, nativeSelect, wrap, false);
        });
    }

    function selectOption(optEl, nativeSelect, wrap, triggerChange = true) {
        const val = optEl.dataset.value;
        wrap.querySelectorAll('.custom-select__option').forEach(o => o.classList.remove('is-selected'));
        optEl.classList.add('is-selected');
        wrap.querySelector('.custom-select__trigger span').textContent = optEl.textContent;
        nativeSelect.value = val;
        if (triggerChange) {
            nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        wrap.classList.remove('is-open');
    }

    const spinner = root.querySelector('.wpcf7-spinner');
    const formCol = root.querySelector('.contact__formcol');

    if (spinner && formCol) {
        const updateSpinnerOverlay = () => {
            const rect = formCol.getBoundingClientRect();
            spinner.style.setProperty('--overlay-width', `${rect.width}px`);
            spinner.style.setProperty('--overlay-height', `${rect.height}px`);
        };

        updateSpinnerOverlay();

        window.addEventListener('resize', updateSpinnerOverlay);
        document.addEventListener('wpcf7beforesubmit', updateSpinnerOverlay);
    }

    (function () {
        const contactRoot = document.querySelector('[data-contact]');
        if (!contactRoot) return;

        const thanksWrap = contactRoot.querySelector('.contact__thanks-container');
        const thanksModal = thanksWrap?.querySelector('.contact__thanks');
        const thanksOverlay = thanksWrap?.querySelector('.contact__thanks-overlay');
        const closeBtns = thanksWrap?.querySelectorAll('[data-modal-close]') || [];

        if (!thanksWrap || !thanksModal) return;

        function lockScroll() {
            const y = window.scrollY || 0;
            document.body.dataset.scrollY = y;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${y}px`;
            document.body.style.width = '100%';
        }
        function unlockScroll() {
            const y = parseInt(document.body.dataset.scrollY || '0', 10);
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            window.scrollTo(0, y);
        }

        function openThanksModal() {
            thanksWrap.classList.add('is-open');
            thanksModal.hidden = false;
            lockScroll();
            const firstClose = thanksWrap.querySelector('[data-modal-close]');
            firstClose?.focus({ preventScroll: true });
        }

        function closeThanksModal() {
            thanksWrap.classList.remove('is-open');
            thanksModal.hidden = true;
            unlockScroll();
        }

        document.addEventListener('wpcf7mailsent', (e) => {
            if (contactRoot.contains(e.target)) {
                openThanksModal();
            }
        });

        thanksOverlay?.addEventListener('click', closeThanksModal);
        closeBtns.forEach(btn => btn.addEventListener('click', closeThanksModal));
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && thanksWrap.classList.contains('is-open')) {
                closeThanksModal();
            }
        });
    })();
});
